import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  dialogTitle:{
    padding: '24px 24px 15px',
  },
  dialogButton:{
    fontSize: '14px',
    textAlign: 'center',
    width: '100%',
    padding: '2px',
    margin:'3px',
    color: 'white',
  },
  listItem: {
    backgroundColor: '#B71C1C',
    borderRadius: 3,
    padding: '2px',
    margin:'3px'
  },
  listItemText: {
    textAlign: 'center',
    width: '100%',
    padding: '2px',
    margin:'3px',
    color: 'white',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

class GeneralDialog extends Component {
  state = {
    open: true,
    fullWidth: true,
    maxWidth: 'lg',
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {classes, location} = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick="true"
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          className={classes.dialog}
        >
          <DialogTitle id="customized-dialog-title" className={classes.dialogTitle} onClose={this.handleClose}>
              {this.props.title && <Typography variant="h6" style={{fontSize: '20px', color:'#B71C1C'}}>{this.context.t(this.props.title)}</Typography>}
              {this.props.title2 && <Typography>{this.context.t(this.props.title2)}</Typography>}
              {this.state.open ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={()=>{this.props.showDialog(this.props.typeDialog, false)}}>
                  <CloseIcon style={{ fontSize: '40px' }}  />
                </IconButton>
              ) : null}
          </DialogTitle>
          
          {this.props.component}

        </Dialog>
      </div>
    );
  }
}

GeneralDialog.contextTypes = {
  t: PropTypes.func
}

export default withStyles(styles)(GeneralDialog);